import {Routes} from '@angular/router';
import {LoginComponent} from './public/login/login.component';
import {ForgotPasswordComponent} from "./public/forgot-password/forgot-password.component";
// import {ChangePasswordComponent} from "./pages/change-password/change-password.component";

export const routes: Routes = [
  {
    path: 'pages',
    loadChildren: () => import('./pages/pages.routes').then(m => m.pagesRoutes)
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  // {
  //   path: 'change-password',
  //   component: ChangePasswordComponent
  // },
  {
    path: 'login/:token',
    component: LoginComponent
  },
{
    path: '',
    redirectTo: 'pages/usuarios',
    pathMatch: 'full',
  },
  {path: '**', redirectTo: 'pages/usuarios'},
];